export default "__VITE_ASSET__BKoxOpKc__"